// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import styles from "./styles.scss";

// TODO:
type Props = {
  data: {
    imageUrl: any,
    backButtonText?: string,
    onBackPress: () => void,
    bannerData: Object,
  },
  theme: string,
};

const ArchitectureDesignBanner = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    bannerData: {
      image,
      image_mobile,
      thumbnail,
      title,
      sub_heading,
      banner_video,
    },
  } = props.data;
  let className = 'architecture-design-banner';
  let bannerImage = image;
  let thumbNailUrl = thumbnail;
  if (isMobile) {
    bannerImage = image_mobile;
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'banner-image'}
        imageUrl={bannerImage}
        thumbNailUrl={thumbNailUrl}
        title={title}
        titleHeading={sub_heading}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && <FooterExploreButton sectionName={'design-philosophy'} />}
    </div>
  );
};

export default withRouter(ArchitectureDesignBanner);
